import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import {MdDialog, MdDialogRef} from '@angular/material';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { AddSubcategoryComponent } from '../add-subcategory/add-subcategory.component';
import { EditSubcategoryComponent } from '../edit-subcategory/edit-subcategory.component';

@Component({
  selector: 'app-subcategories',
  templateUrl: './subcategories.component.html',
  styleUrls: ['./subcategories.component.css']
})
export class SubcategoriesComponent implements OnInit {
	subcategories: FirebaseListObservable<any[]>;
  selectedOption: string;
  currentUser;

  constructor(db: AngularFireDatabase, public afAuth: AngularFireAuth, public dialog: MdDialog ) 
  {
    this.afAuth.authState.subscribe(res => {
      this.currentUser = res;
      this.subcategories = db.list('/staging/subcategories/-'+ this.currentUser.uid);
      });
  }

  ngOnInit() { 
  }

  addSubcategory() {
    let dialogRef = this.dialog.open(AddSubcategoryComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedOption = result;
        this.subcategories.push({ subcategoryName: result });
      }
    });
  }

  editSubcategory(subcategory) {
    let dialogRef = this.dialog.open(EditSubcategoryComponent, {data: subcategory});
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        subcategory.subcategoryName = result;
        this.subcategories.update( subcategory.$key, {subcategoryName: subcategory.subcategoryName} );
      }
    });
  }

}



// WEBPACK FOOTER //
// d:/xampp/htdocs/zenith-admin/src/app/subcategories/subcategories.component.ts